// extracted by mini-css-extract-plugin
module.exports = {"logo_small":"logo_logo_small__vaHPR"};